<template>
<footer class="container-fluid bg-dark mt-auto footer">
  <div class="d-flex flex-wrap justify-content-between align-items-center">
    <div class="col-md-4 d-flex align-items-center">
      <span class="text-muted small">Designed by: SmirkyGraphs</span>
    </div>
    <div class="col-md-4 d-flex flex-end justify-content-end">
      <span class="text-muted small">{{ formattedTime(timestamp) }}</span>
    </div>
  </div>
</footer>
</template>

<script>
import { format } from "date-fns";

export default {
  props: {
    timestamp: Number,
  },
  name: "Footer",
  methods: {
    formattedTime(timestamp) {
      var tempDate = (new Date(timestamp))
      return format(tempDate, "M/dd/yyyy hh:mm a")
    }
  }
}
</script>